export default __webpack_public_path__ + "static/media/AM_00858 copy.03e73672.jpg";